/**
 * A function to load a resource and wait for it to load.
 *
 * @param document The reference to the document object.
 * @param url The resource URL.
 * @param isScript Is this resource a script or a stylesheet?
 * @param skipLoading Function to determine if the resource should not be loaded.
 * @param attributes Extra attributes to add on the HTML element before attaching it to the document.
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function loadResource(document, url, isScript, skipLoading, attributes) {
    if (isScript === void 0) { isScript = true; }
    if (skipLoading && skipLoading())
        return Promise.resolve();
    return new Promise(function (resolve, reject) {
        var resource;
        if (isScript) {
            resource = document.createElement('script');
            (resource).src = url;
        }
        else {
            resource = document.createElement('link');
            (resource).href = url;
            (resource).rel = 'stylesheet';
        }
        if (attributes) {
            var keys = Object.keys(attributes);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                resource.setAttribute(key, attributes[key]);
            }
        }
        resource.addEventListener('load', function () { return resolve(); });
        resource.addEventListener('error', function () { return reject(new Error("Script load error for url: ".concat(url, "."))); });
        document.head.appendChild(resource);
    });
}
//# sourceMappingURL=loadResource.js.map